import React from "react"
import { Seo } from "./seo"
//import { Seo as SeoI18n } from "gatsby-theme-i18n"

import { Theme } from "./theme"

const Head = ({
  title,
  description,
  image,
  doNotIndex,
  location,
  pageContext,
  data,
  ld,
}) => {
  return (
    <>
      <Seo
        title={title}
        image={image}
        description={description}
        doNotIndex={doNotIndex}
        location={location}
        ld={ld}
        data={data}
        pageContext={pageContext}
      />
      <Theme />
    </>
  )
}

export { Head }
